module.exports = __webpack_public_path__ + "img/红井.76229138.png";